/* eslint-disable no-param-reassign -- intentionally mutates window analytics stub */
import { ONE_TRUST_PERFORMANCE_GROUP } from './oneTrustCategories';
import { hasOneTrustGroup } from './oneTrustConsent';

export function normalizeAnalyticsStub(win) {
    if (win.analytics && !Array.isArray(win.analytics) && !win.analytics.initialize) {
        win.analytics = [];
    }

    if (!win.analytics) {
        win.analytics = [];
    }

    return win.analytics;
}

export function shouldLoadSegmentOnInit(activeGroups) {
    return hasOneTrustGroup(activeGroups, ONE_TRUST_PERFORMANCE_GROUP);
}

export function createInitSegment(analytics, segmentKey) {
    return function initSegment() {
        analytics.load(segmentKey);
    };
}

export function revokeSegment(win) {
    // eslint-disable-next-line no-underscore-dangle -- window consent globals use vendor-prefixed names
    const stub = win.__segmentStub;

    if (!stub || win.analytics === stub) {
        return;
    }

    if (win.analytics && typeof win.analytics.reset === 'function') {
        win.analytics.reset();
    }

    win.analytics = stub;
}
